import { render, staticRenderFns } from "./UserPending.vue?vue&type=template&id=5779ab55"
import script from "./UserPending.vue?vue&type=script&lang=js"
export * from "./UserPending.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports